import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import {
  closeRatingModal,
  clearActiveRating,
  clearRatingPayload,
  setRatings,
} from '../RatingSlice';

export default function useHandleGetRatingSuccess({ isSuccess, data }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess) {
      if (!data.data.length) {
        dispatch(closeRatingModal());
        dispatch(clearActiveRating());
        dispatch(clearRatingPayload());
      }
      dispatch(setRatings(data.data));
    }
  }, [isSuccess, data, dispatch]);
}
